import React from "react";
import { connect } from "react-redux";
import { articleIds } from "../../store/reducers";
import { NewsCard } from "./NewsCard";
import { styled } from "../../utils/alias";

const Background = styled.div`
    background-color: #EEE;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const ListContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 970px;
    margin: auto;
    padding: 10px;
`;

const connectRedux = connect(state => ({ articleIds: articleIds(state) }));
let NewsFeed = connectRedux(({ articleIds }) => {
    const firstArticleIndex = 2;
    return (
        <Background>
            <ListContainer>
                {articleIds.map((id, index) => {
                    const isFirst = index === firstArticleIndex;
                    const isRead = index < firstArticleIndex;
                    return (
                        <NewsCard {...{ id, key: id, isFirst, isRead }} />
                    );
                })}
            </ListContainer>
        </Background>
    );
});

export { NewsFeed };



// WEBPACK FOOTER //
// ./src/components/feed/NewsFeed.js